<div class="worksheet-config-modal" (window:resize)="onResize()">
  <div class="col-12 header">
    <div class="row">
      <div class="col-10 title">HABILITE OU DESABILITE AS COLUNAS</div>
      <div class="col-2 icon">
        <mat-icon class="icon-close" (click)="close()" svgIcon="close"></mat-icon>
      </div>
    </div>
  </div>
  <div class="col-12 actions divisor">
    <div class="row">
      <div class="col-4 p-0 border-l">
        <span class="" (click)="clearColumns()">Limpar Colunas</span>
      </div>
      <div class="col-4 p-0 border-l">
        <span class="" (click)="defaultColumns()">Redefinir Colunas</span>
      </div>
      <div class="col-4 p-0">
        <span class="" (click)="close()">Concluir</span>
      </div>
    </div>
  </div>
  <div class="col-12 content">
    <div class="row" *ngFor="let item of listColumns; let i = index">
      <div class="col-12">
        <mat-checkbox class="check-options" [ngClass]="{'checked': modelList[i]}" (change)="onChange($event, i)"
          [(ngModel)]="modelList[i]" labelPosition="after" [disableRipple]="item.fixedItem" [checked]="item.fixedItem"
          (click)="item.fixedItem ? $event.preventDefault() : ''">
          <span *ngIf="item.field === 'deltaVolumeCurrentTime' || item.field === 'deltaVolumeAccumulatedHour'">
            <i class="fa fa-sort-asc delta"></i>
          </span>
          {{item.header}}
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>